export default "__VITE_ASSET__92fbf0cc__"